import { connect } from 'react-redux';
import AppDetails from 'components/AppDetails';
import App from 'models/app';
import { translations, translateAll } from 'i18n';

import { uninstallApp } from 'actions/gallery';

const mapStateToProps = (state) => {
  const {
    app: { loading, error, entry },
    features: {
      flags: { showHiggsCU2 }
    },
    installed: { loading: installedLoading },
    installedApps = {},
    currentUser
  } = state.registry;

  const {
    currentlySyncing,
    deviceInfo: { phoneAppVersion },
    syncMode
  } = state.gallery;

  let app;
  let isClock = false;
  if (entry) {
    app = App.selectFromState(entry, state);
    isClock = app.isClock;
  }

  const {
    page: {
      [isClock ? 'Clock' : 'App']: {
        InstallButtonState,
        Navigation: { backText },
        Details: {
          cannotInstallNotice,
          cannotInstallNoticeNoVersion,
          cannotInstallNoticeNoVersionLink,
          cannotInstallNoticeDeviceDisconnected,
          descriptionSectionTitle,
          detailsSectionTitle,
          screenshotsSectionTitle
        }
      }
    }
  } = translations;

  const {
    component: {
      AppDetails: {
        flags: { RESTRICTED_FOR_REGION }
      }
    }
  } = translations;

  let showRemove = false;
  // show remove button for apps only
  if (app && !isClock && app.isRemovable) {
    showRemove = true;
  }

  return {
    loading,
    installedLoading:
      Object.keys(installedApps).length === 0 && installedLoading,
    app,
    currentlySyncing,
    phoneAppVersion,
    showHiggsCU2,
    syncMode,
    error,
    currentUser,
    installTexts: translateAll(InstallButtonState),
    cannotInstallNotice: cannotInstallNotice(),
    cannotInstallNoticeNoVersion: cannotInstallNoticeNoVersion(),
    cannotInstallNoticeNoVersionLink: cannotInstallNoticeNoVersionLink(),
    cannotInstallNoticeDeviceDisconnected: cannotInstallNoticeDeviceDisconnected(),
    descriptionSectionTitle: descriptionSectionTitle(),
    detailsSectionTitle: detailsSectionTitle(),
    screenshotsSectionTitle: screenshotsSectionTitle(),
    restrictedRegionMessage: RESTRICTED_FOR_REGION({
      type: isClock ? 'clock face' : 'app'
    }),
    showRemove,
    backText: backText(),
    backUrl: isClock ? '/clocks/gallery' : '/apps/gallery'
  };
};

const mapDispatchToProps = (dispatch, { payload: { id } }) => ({
  uninstallApp: () => dispatch(uninstallApp(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(AppDetails);
